import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { fetchAuctions } from '@/services/api';
import type { Database } from '@/lib/database.types';

const STATUS_LABELS: Record<string, string> = {
  ENTWURF: 'Entwurf',
  LAUFEND: 'Laufend',
  BEENDET_PRUEFUNG: 'In Prüfung',
  LAUFEND_RESERVE: 'Reserve-Bietung',
  ZUSCHLAG_VORLAEUFIG: 'Zuschlag (vorläufig)',
  ZUSCHLAG_FINAL: 'Zuschlag (final)',
  BEENDET_OHNE_ZUSCHLAG: 'Beendet',
};

function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString('de-DE');
}

import { NewAuctionForm } from './NewAuctionForm';

export function AdminAuctionsPage() {
  const [auctions, setAuctions] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showNew, setShowNew] = useState(false);

  useEffect(() => { loadAuctions(); }, []);

  async function loadAuctions() {
    const auctions = await fetchAuctions();
    setAuctions(auctions);
    setLoading(false);
  }

  return (
    <div className="container-content py-12">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-serif">Auktionen verwalten</h1>
        <button onClick={() => setShowNew(!showNew)} className="btn-primary">Neue Auktion</button>
      </div>

      {loading ? (
        <p className="text-text-secondary">Laden...</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Aktenzeichen</th>
              <th>Titel</th>
              <th>Status</th>
              <th>Start</th>
              <th>Ende</th>
              <th>Mindestgebot</th>
            </tr>
          </thead>
          <tbody>
            {auctions.map((a) => (
              <tr key={a.id}>
                <td className="font-mono text-sm">{a.aktenzeichen}</td>
                <td>{a.titel}</td>
                <td>{STATUS_LABELS[a.status] || a.status}</td>
                <td>{formatDate(a.start_at)}</td>
                <td>{formatDate(a.end_at)}</td>
                <td>{a.mindestgebot}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {showNew && <NewAuctionForm onClose={() => setShowNew(false)} />}
    </div>
  );
}

export function AdminAuctionDetailPage() {
  return (
    <div className="container-content py-12">
      <h1 className="text-2xl font-serif mb-6">Auktions-Detail</h1>
      <p className="text-text-secondary">Detail-Ansicht mit allen Geboten und Klarnamen. (Platzhalter)</p>
    </div>
  );
}

export function AdminAuctionAnalyticsPage() {
  return (
    <div className="container-content py-12">
      <h1 className="text-2xl font-serif mb-6">Analytics</h1>

      {/* Block A: Kennzahlen (placeholder) */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
        <div className="p-4 border border-surface-border rounded-sm"><div className="text-sm text-text-muted">Aufrufe</div><div className="text-xl font-serif">—</div></div>
        <div className="p-4 border border-surface-border rounded-sm"><div className="text-sm text-text-muted">Eindeutige Betrachter</div><div className="text-xl font-serif">—</div></div>
        <div className="p-4 border border-surface-border rounded-sm"><div className="text-sm text-text-muted">Sessions</div><div className="text-xl font-serif">—</div></div>
        <div className="p-4 border border-surface-border rounded-sm"><div className="text-sm text-text-muted">Ø Verweildauer</div><div className="text-xl font-serif">—</div></div>
      </div>

      {/* Block B: Viewer-Tabelle (placeholder) */}
      <h2 className="text-lg font-serif mb-3">Wer hat wie oft angeschaut</h2>
      <p className="text-text-secondary text-sm mb-8">Keine Daten vorhanden.</p>

      {/* Block C: Section-Heatmap (placeholder) */}
      <h2 className="text-lg font-serif mb-3">Fokuszeit pro Abschnitt</h2>
      <p className="text-text-secondary text-sm">Keine Daten vorhanden.</p>
    </div>
  );
}

export function AdminUsersPage() {
  return (
    <div className="container-content py-12">
      <h1 className="text-2xl font-serif mb-6">Nutzer</h1>
      <p className="text-text-secondary text-sm">Alle Nutzer mit Klardaten und Login-Historie. (Platzhalter)</p>
    </div>
  );
}

export function AdminInvitationsPage() {
  return (
    <div className="container-content py-12">
      <h1 className="text-2xl font-serif mb-6">Einladungscodes</h1>
      <p className="text-text-secondary text-sm">Codes generieren, einsehen, deaktivieren. (Platzhalter)</p>
    </div>
  );
}

export function AdminZuschlaegePage() {
  return (
    <div className="container-content py-12">
      <h1 className="text-2xl font-serif mb-6">Zuschläge und Compliance</h1>
      <p className="text-text-secondary text-sm">Zuschlagsprozesse und Compliance-Status. (Platzhalter)</p>
    </div>
  );
}

export function AdminAnfragenPage() {
  return (
    <div className="container-content py-12">
      <h1 className="text-2xl font-serif mb-6">Eingehende Anfragen</h1>
      <p className="text-text-secondary text-sm">Inbox + Statusverfolgung. (Platzhalter)</p>
    </div>
  );
}

export function AdminProtokollePage() {
  return (
    <div className="container-content py-12">
      <h1 className="text-2xl font-serif mb-6">Audit-Protokolle</h1>
      <p className="text-text-secondary text-sm">System-Audit-Log. (Platzhalter)</p>
    </div>
  );
}
